var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import * as React from 'react'; // tslint:disable-line
import { useMemo } from 'react';
import styled, { css, withTheme } from 'styled-components';
import { classNames, cn, toArray } from '@shapeable/utils';
var cls = classNames('select');
import { startsWith, pickBy, first } from 'lodash';
import { breakpoints, theme } from '@shapeable/theme';
import ReactSelect, { createFilter, components as Components } from 'react-select';
import Highlighter from 'react-highlight-words';
import AsyncSelect from 'react-select/async';
import AsyncCreatable from 'react-select/async-creatable';
import Creatable from 'react-select/creatable';
import { AsyncPaginate } from 'react-select-async-paginate';
import { Icon } from './icon';
import { Badge } from './badge';
import { PlusIcon, SearchIcon } from '@shapeable/icons';
import { useActiveThemeMode } from '../hooks/use-active-theme-mode';
export var SelectDefaultProps = {
  noOptionsMessage: function () {
    return null;
  },
  fontSize: 16,
  valid: true,
  placeholder: '(None)',
  fontSizeMulti: 14,
  textColor: 'textTag',
  isLoading: false,
  isSearchable: true,
  isClearable: true,
  isMulti: false,
  options: [],
  borderless: false,
  borderStyle: 'solid',
  onChange: function (value) {
    console.log(value);
  }
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n    text-transform: none;\n  "], ["\n    display: flex;\n    flex-direction: column;\n    text-transform: none;\n  "])))
});
var SelectStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    width: 100%;\n    ", "\n\n    input {\n      font-family: ", ";\n    }\n  "], ["\n    width: 100%;\n    ", "\n\n    input {\n      font-family: ", ";\n    }\n  "])), function (props) {
    return props._maxWidth && css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      max-width: ", ";\n    "], ["\n      max-width: ", ";\n    "])), props._maxWidth);
  }, theme.FONT('sans'))
});
var AfterSelectStyles = breakpoints({
  base: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    display: flex;\n    align-items: flex-end;\n    margin-top: ", ";\n    padding: 2px 0 1px 12px;\n    border-left: 2px solid ", ";\n    margin-left: 1px;\n  "], ["\n    display: flex;\n    align-items: flex-end;\n    margin-top: ", ";\n    padding: 2px 0 1px 12px;\n    border-left: 2px solid ", ";\n    margin-left: 1px;\n  "])), theme.UNIT(2.5), theme.COLOR('line-mid'))
});
var OptionStyles = breakpoints({
  base: css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    display: flex;\n    align-items: center;\n  \n    ", "\n  "], ["\n    display: flex;\n    align-items: center;\n  \n    ", "\n  "])), function (props) {
    return props.isCreate && css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n      color: ", ";\n      font-weight: 500;\n      font-size: 1em;\n    "], ["\n      color: ", ";\n      font-weight: 500;\n      font-size: 1em;\n    "])), theme.COLOR('primary'));
  })
});
var ImageStyles = breakpoints({
  base: css(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    object-fit: cover;\n    margin-right: ", ";\n    margin-left: ", ";\n    position: relative;\n    height: 32px;\n    \n    ", "\n\n    ", "\n\n  "], ["\n    object-fit: cover;\n    margin-right: ", ";\n    margin-left: ", ";\n    position: relative;\n    height: 32px;\n    \n    ", "\n\n    ", "\n\n  "])), theme.UNIT(3), theme.UNIT(1), function (props) {
    return props._tall && css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n      height: 42px;\n    "], ["\n      height: 42px;\n    "])));
  }, function (props) {
    return props._round && css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n      border-radius: 50%;\n      border: 1px solid ", ";\n    "], ["\n      border-radius: 50%;\n      border: 1px solid ", ";\n    "])), theme.COLOR('line-mid'));
  })
});
var MultiImageStyles = breakpoints({
  base: css(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n    object-fit: cover;\n    margin-right: ", ";\n    margin-left: ", ";\n    position: relative;\n    height: 28px;\n    \n    ", "\n\n    ", "\n\n  "], ["\n    object-fit: cover;\n    margin-right: ", ";\n    margin-left: ", ";\n    position: relative;\n    height: 28px;\n    \n    ", "\n\n    ", "\n\n  "])), theme.UNIT(3), theme.UNIT(1), function (props) {
    return props._tall && css(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n      height: 38px;\n    "], ["\n      height: 38px;\n    "])));
  }, function (props) {
    return props._round && css(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n      border-radius: 50%;\n      border: 1px solid ", ";\n    "], ["\n      border-radius: 50%;\n      border: 1px solid ", ";\n    "])), theme.COLOR('line-mid'));
  })
});
var ValueLayoutStyles = breakpoints({
  base: css(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n    display: flex;\n    align-items: center;\n    overflow: visible;\n    margin-left: 0px;\n  "], ["\n    display: flex;\n    align-items: center;\n    overflow: visible;\n    margin-left: 0px;\n  "])))
});
var IconStyles = breakpoints({
  base: css(templateObject_14 || (templateObject_14 = __makeTemplateObject(["\n    margin-left: ", ";\n    margin-right: ", ";\n    position: relative;\n  "], ["\n    margin-left: ", ";\n    margin-right: ", ";\n    position: relative;\n  "])), theme.UNIT(1), theme.UNIT(2))
});
var MultiValueIconStyles = breakpoints({
  base: css(templateObject_15 || (templateObject_15 = __makeTemplateObject(["\n    margin-right: ", ";\n    position: relative;\n  "], ["\n    margin-right: ", ";\n    position: relative;\n  "])), theme.UNIT(2))
});
var SummaryStyles = breakpoints({
  base: css(templateObject_16 || (templateObject_16 = __makeTemplateObject(["\n    padding-top: ", ";\n    padding-bottom: ", ";\n    font-size: 0.75em;\n    line-height: 1.4em;\n  "], ["\n    padding-top: ", ";\n    padding-bottom: ", ";\n    font-size: 0.75em;\n    line-height: 1.4em;\n  "])), theme.UNIT(3), theme.UNIT(1))
});
var SearchIconStyles = breakpoints({
  base: css(templateObject_17 || (templateObject_17 = __makeTemplateObject(["\n    margin-left: ", ";\n    margin-right: ", ";\n  "], ["\n    margin-left: ", ";\n    margin-right: ", ";\n  "])), theme.UNIT(3), theme.UNIT(3))
});
var BadgeStyles = breakpoints({
  base: css(templateObject_18 || (templateObject_18 = __makeTemplateObject(["\n    margin-left: ", ";\n  "], ["\n    margin-left: ", ";\n  "])), theme.UNIT(5))
});
var ValueContainerLayoutStyles = breakpoints({
  base: css(templateObject_19 || (templateObject_19 = __makeTemplateObject(["\n    position: relative;\n  "], ["\n    position: relative;\n  "])))
});
var CreateIconButtonStyles = breakpoints({
  base: css(templateObject_20 || (templateObject_20 = __makeTemplateObject(["\n    position: absolute;\n    right: 0;\n  "], ["\n    position: absolute;\n    right: 0;\n  "])))
});
var SingleValueImageStyles = breakpoints({
  base: css(templateObject_21 || (templateObject_21 = __makeTemplateObject(["\n    margin-right: 12px;\n    padding-right: 0px;\n    height: 34px;\n    position: relative;\n    display: flex;\n    flex-shrink: 0;\n    align-items: center;\n\n    img {\n      margin-right: 12px;\n    }\n  "], ["\n    margin-right: 12px;\n    padding-right: 0px;\n    height: 34px;\n    position: relative;\n    display: flex;\n    flex-shrink: 0;\n    align-items: center;\n\n    img {\n      margin-right: 12px;\n    }\n  "])))
});
var MultiValueImageStyles = breakpoints({
  base: css(templateObject_22 || (templateObject_22 = __makeTemplateObject(["\n    padding-right: 0px;\n    height: 34px;\n    margin-left: -8px;\n    position: relative;\n    display: flex;\n    flex-shrink: 0;\n    align-items: center;\n  "], ["\n    padding-right: 0px;\n    height: 34px;\n    margin-left: -8px;\n    position: relative;\n    display: flex;\n    flex-shrink: 0;\n    align-items: center;\n  "])))
});
var SingleValueBorderStyles = breakpoints({
  base: css(templateObject_23 || (templateObject_23 = __makeTemplateObject(["\n    height: 32px;\n    width: 0px;\n    position: relative;\n    top: 1px;\n    font-size: 0;\n    border-right: 1px solid ", ";\n  "], ["\n    height: 32px;\n    width: 0px;\n    position: relative;\n    top: 1px;\n    font-size: 0;\n    border-right: 1px solid ", ";\n  "])), theme.COLOR('line-mid'))
});
var OptionTextStyles = breakpoints({
  base: css(templateObject_24 || (templateObject_24 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n  "], ["\n    display: flex;\n    flex-direction: column;\n  "])))
});
var SubLabelStyles = breakpoints({
  base: css(templateObject_25 || (templateObject_25 = __makeTemplateObject(["\n    display: inline-block;\n    padding-top: ", ";\n    font-size: ", ";\n  "], ["\n    display: inline-block;\n    padding-top: ", ";\n    font-size: ", ";\n  "])), theme.UNIT(1), theme.FONT_SIZE(14))
});
// -------- Components -------->
var My = {
  Container: styled.div(templateObject_26 || (templateObject_26 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Select: styled(ReactSelect)(templateObject_27 || (templateObject_27 = __makeTemplateObject(["", ""], ["", ""])), SelectStyles),
  AsyncSelect: styled(AsyncSelect)(templateObject_28 || (templateObject_28 = __makeTemplateObject(["", ""], ["", ""])), SelectStyles),
  AsyncCreatable: styled(AsyncCreatable)(templateObject_29 || (templateObject_29 = __makeTemplateObject(["", ""], ["", ""])), SelectStyles),
  // @ts-ignore
  AsyncSelectPaginate: styled(AsyncPaginate)(templateObject_30 || (templateObject_30 = __makeTemplateObject(["", ""], ["", ""])), SelectStyles),
  OptionLayout: styled.div.attrs(cls.attr('option-layout'))(templateObject_31 || (templateObject_31 = __makeTemplateObject(["", ""], ["", ""])), OptionStyles),
  OptionText: styled.div.attrs(cls.attr('option-text'))(templateObject_32 || (templateObject_32 = __makeTemplateObject(["", ""], ["", ""])), OptionTextStyles),
  SubLabel: styled.span.attrs(cls.attr('sub-label'))(templateObject_33 || (templateObject_33 = __makeTemplateObject(["", ""], ["", ""])), SubLabelStyles),
  ValueLayout: styled.div.attrs(cls.attr('value-layout'))(templateObject_34 || (templateObject_34 = __makeTemplateObject(["", ""], ["", ""])), ValueLayoutStyles),
  ValueContainerLayout: styled.div.attrs(cls.attr('value-container-layout'))(templateObject_35 || (templateObject_35 = __makeTemplateObject(["", ""], ["", ""])), ValueContainerLayoutStyles),
  Image: styled.img.attrs(cls.attr('image'))(templateObject_36 || (templateObject_36 = __makeTemplateObject(["", ""], ["", ""])), ImageStyles),
  SingleValueImage: styled.div.attrs(cls.attr('single-value-image'))(templateObject_37 || (templateObject_37 = __makeTemplateObject(["", ""], ["", ""])), SingleValueImageStyles),
  SingleValueBorder: styled.div.attrs(cls.attr('single-value-border'))(templateObject_38 || (templateObject_38 = __makeTemplateObject(["", ""], ["", ""])), SingleValueBorderStyles),
  Icon: styled(Icon)(templateObject_39 || (templateObject_39 = __makeTemplateObject(["", ""], ["", ""])), IconStyles),
  MultiValueIcon: styled(Icon)(templateObject_40 || (templateObject_40 = __makeTemplateObject(["", ""], ["", ""])), MultiValueIconStyles),
  MultiValueImage: styled.div.attrs(cls.attr('multi-value-image'))(templateObject_41 || (templateObject_41 = __makeTemplateObject(["", ""], ["", ""])), MultiValueImageStyles),
  MultiImage: styled.img.attrs(cls.attr('multi-image'))(templateObject_42 || (templateObject_42 = __makeTemplateObject(["", ""], ["", ""])), MultiImageStyles),
  Summary: styled.div.attrs(cls.attr('summary'))(templateObject_43 || (templateObject_43 = __makeTemplateObject(["", ""], ["", ""])), SummaryStyles),
  SearchIcon: styled(Icon)(templateObject_44 || (templateObject_44 = __makeTemplateObject(["", ""], ["", ""])), SearchIconStyles),
  Badge: styled(Badge)(templateObject_45 || (templateObject_45 = __makeTemplateObject(["", ""], ["", ""])), BadgeStyles)
};
var optWarn = function (item, fieldName) {
  console.warn("[Data Missing] Couldn't map value ".concat(item, " to an option in Input Select '").concat(fieldName, "', which will result in data loss when the form is saved. Please provide the necessary options data inside the fields 'metadata.cacheOptions' property to allow the Async select to reconcile selected values to labels and other metadata."));
};
export var SelectComponent = function (props) {
  var className = props.className,
    onChange = props.onChange,
    textColor = props.textColor,
    borderless = props.borderless,
    id = props.id,
    isDisabled = props.isDisabled,
    formatCreateLabel = props.formatCreateLabel,
    onCreateOption = props.onCreateOption,
    value = props.value,
    focus = props.focus,
    valid = props.valid,
    isMulti = props.isMulti,
    noOptionsMessage = props.noOptionsMessage,
    isSearchable = props.isSearchable,
    placeholder = props.placeholder,
    isClearable = props.isClearable,
    maxWidth = props.maxWidth,
    isLoading = props.isLoading,
    fontSize = props.fontSize,
    fontSizeMulti = props.fontSizeMulti,
    loadOptions = props.loadOptions,
    defaultOptions = props.defaultOptions,
    isOptionDisabled = props.isOptionDisabled,
    borderStyle = props.borderStyle;
  var name = props.name || id;
  var isSearch = loadOptions && !defaultOptions;
  var multiValue = toArray(value);
  var firstValue = first(multiValue);
  var options = loadOptions ? [] : props.options;
  var optionValue = value; // isMulti ? multiValue.map(item => item.value) : firstValue;
  // const ref: any = React.useRef();
  // React.useEffect(() => {
  //   if (ref && ref.current && ref.current.select && focus) {
  //     ref.current.select.focus();
  //   }
  // }, [ref, focus]);
  // allows us to use our props function builders by calling immediately on the current theme (from context)
  // which is likely what styled components does internally anyway.
  var $ = function (func) {
    return func({
      theme: props.theme
    });
  };
  // We can't unfortunately use styled components to override the class name
  // as react-select doesn't support classNames on custom components (seems crazy)
  var mode = useActiveThemeMode();
  var ReactSelectStyles = useMemo(function () {
    return {
      control: function (base, state) {
        return __assign(__assign({}, base), {
          borderRadius: 0,
          minHeight: borderStyle === 'dotted' ? '58px' : '52px',
          fontFamily: $(theme.FONT('sans')),
          fontWeight: 400,
          fontSize: '16px',
          minWidth: '240px',
          backgroundColor: $(theme.COLOR('bright')),
          paddingRight: borderless ? $(theme.UNIT(2)) : 0,
          paddingLeft: borderless ? $(theme.UNIT(2)) : 0,
          paddingBottom: borderless ? 2 : 1,
          width: '100%',
          maxWidth: maxWidth || 'none',
          borderWidth: borderless ? 0 : borderStyle === 'solid' ? 1 : 2,
          borderStyle: borderStyle,
          borderColor: state.isFocused ? $(theme.COLOR('primary')) : $(theme.COLOR(valid ? 'line-mid' : 'error')),
          boxShadow: 'none',
          '&:hover': {
            borderColor: state.isFocused ? $(theme.COLOR('primary')) : $(theme.COLOR(valid ? 'line-mid' : 'error'))
          },
          '>div': {
            overflow: 'visible'
          }
        });
      },
      multiValue: function (base, state) {
        return __assign(__assign({}, base), {
          marginLeft: '6px',
          backgroundColor: borderless ? 'none' : state.data.color || '#EEE',
          marginBottom: '3px',
          marginRight: borderless ? '6px' : '3px',
          marginTop: borderless ? '1px' : '3px',
          padding: borderless ? '6px 0 7px' : state.data.tall ? '4px 8px' : '4px 6px',
          borderWidth: borderless ? 0 : 1,
          display: 'flex',
          fontSize: '1em',
          alignItems: 'center',
          borderRadius: borderless ? 0 : '4px',
          height: state.data.tall ? '48px' : 'auto',
          borderColor: borderless ? '#EEE' : state.data.color || 'transparent',
          'svg path, svg circle, svg polygon, svg rect': {
            fill: $(theme.COLOR(textColor || 'text-tag'))
          }
        });
      },
      multiValueLabel: function (base, state) {
        return __assign(__assign({}, base), {
          fontWeight: borderless ? '500' : '400',
          paddingLeft: borderless ? '2px' : '6px',
          fontSize: '1em'
        });
      },
      clearIndicator: function (base, state) {
        return __assign(__assign({}, base), {
          alignSelf: 'flex-start',
          marginTop: '8px',
          color: $(theme.COLOR(textColor || 'line')),
          'svg path, svg circle, svg polygon, svg rect': {
            fill: $(theme.COLOR('line'))
          },
          '&:hover': {
            color: $(theme.COLOR('primary')),
            'svg path, svg circle, svg polygon, svg rect': {
              fill: $(theme.COLOR('primary'))
            }
          }
        });
      },
      multiValueRemove: function (base, state) {
        return __assign(__assign({}, base), {
          padding: '0 1px',
          marginLeft: 4,
          marginRight: 2,
          height: '16px',
          borderRadius: '20px',
          color: $(theme.COLOR(textColor || 'text-tag')),
          '&:hover': {
            'svg path, svg circle, svg polygon, svg rect': {
              fill: $(theme.COLOR('light'))
            },
            background: $(theme.COLOR('primaryDarker')),
            color: $(theme.COLOR('light'))
          }
        });
      },
      menu: function (base, state) {
        return __assign(__assign({}, base), {
          zIndex: 201,
          borderRadius: 0,
          backgroundColor: $(theme.COLOR('bright')),
          borderColor: $(theme.COLOR('subtle')),
          borderWidth: 1,
          borderStyle: 'solid',
          marginTop: 4,
          maxWidth: maxWidth || 'none'
        });
      },
      input: function (base, state) {
        return __assign(__assign({}, base), {
          fontFamily: $(theme.FONT('sans')),
          paddingLeft: borderless ? $(theme.UNIT(2)) : $(theme.UNIT(3)),
          paddingTop: borderless ? $(theme.UNIT(2)) : 0,
          paddingBottom: borderless ? $(theme.UNIT(2)) : 0,
          marginLeft: 0
        });
      },
      indicatorSeparator: function (base, state) {
        return __assign(__assign({}, base), {
          display: borderless ? 'none' : 'block',
          width: '1px',
          background: $(theme.COLOR('line-mid'))
        });
      },
      dropdownIndicator: function (base, state) {
        return __assign(__assign({}, base), {
          alignSelf: 'flex-start',
          marginTop: '7px',
          color: state.isFocused || state.isActive ? $(theme.COLOR('primary')) : $(theme.COLOR('sub')),
          '&:hover': {
            color: $(theme.COLOR('primary'))
          }
        });
      },
      singleValue: function (base, state) {
        return __assign(__assign({}, base), {
          color: $(theme.COLOR('strong')),
          fontWeight: 400,
          paddingLeft: 10,
          whiteSpace: 'nowrap',
          textOverflow: 'ellipsis',
          overflow: 'visible',
          overflowX: 'hidden',
          overflowY: 'visible',
          width: '100%'
        });
      },
      valueContainer: function (base, state) {
        return __assign(__assign({}, base), {
          padding: borderless ? '5px 2px 2px 0' : '3px 2px 2px 0'
        });
      },
      placeholder: function (base, state) {
        return __assign(__assign({}, base), {
          color: $(theme.COLOR(valid ? 'text-tag' : 'error')),
          fontWeight: 400,
          paddingLeft: borderless ? $(theme.UNIT(2)) : $(theme.UNIT(3)),
          marginLeft: 0,
          fontSize: '16px',
          fontFamily: $(theme.FONT('sans')),
          whiteSpace: 'nowrap',
          textOverflow: 'ellipsis',
          overflow: 'hidden',
          width: '100%'
        });
      },
      option: function (base, state) {
        var path = !state.isSelected ? {} : {
          'svg path, svg circle, svg polygon, svg rect': {
            fill: state.isSelected ? $(theme.COLOR('bright')) : 'inherit'
          }
        };
        return __assign(__assign(__assign({}, base), {
          opacity: state.isDisabled ? 0.3 : 1.0,
          color: state.isSelected ? $(theme.COLOR('strong')) : state.isFocused ? $(theme.COLOR('strong')) : $(theme.COLOR('text')),
          minHeight: state.data.tall ? '64px' : 'auto',
          borderBottom: "1px solid ".concat($(theme.COLOR('lineSubtle'))),
          fontWeight: 400,
          paddingTop: '12px',
          paddingBottom: '12px',
          fontSize: '16px',
          paddingLeft: $(theme.UNIT(3)),
          backgroundColor: state.isSelected ? $(theme.COLOR('highlight')) : state.isFocused ? $(theme.COLOR('highlight')) : $(theme.COLOR('bright'))
        }), path);
      },
      noOptionsMessage: function (base) {
        return __assign(__assign({}, base), {
          justifyContent: 'flex-start',
          fontWeight: 400
        });
      }
    };
  }, [theme, valid, mode.themeMode]);
  var Option = function (props) {
    var Icon = props.data.icon;
    var Image = props.data.image || props.data.optionImage;
    var selectProps = props.selectProps;
    var inputValue = selectProps.inputValue;
    var isCreateLabel = startsWith(props.label, 'Create ');
    return React.createElement(Components.Option, __assign({}, props), React.createElement(My.OptionLayout, {
      isCreate: isCreateLabel
    }, isCreateLabel && React.createElement(My.Icon, {
      size: props.data.tall ? 32 : 24,
      color: props.data.color || 'primary'
    }, React.createElement(PlusIcon, null)), !Image && Icon && React.createElement(My.Icon, {
      size: props.data.tall ? 32 : 24,
      color: props.data.color || 'text'
    }, React.createElement(Icon, null)), Image && React.createElement(My.Image, {
      _round: props.data.round,
      _tall: props.data.tall,
      src: Image
    }), React.createElement(My.OptionText, null, React.createElement(Highlighter, {
      searchWords: [inputValue],
      textToHighlight: props.data.label
    }), React.createElement(My.SubLabel, null, props.data.subLabel)), props.data.badge && React.createElement(My.Badge, null, props.data.badge)), props.data.description && React.createElement(My.Summary, null, props.data.description));
  };
  var DropdownIndicator = function (props) {
    return loadOptions && !defaultOptions ? React.createElement(My.SearchIcon, {
      size: 20
    }, React.createElement(SearchIcon, null)) : React.createElement(Components.DropdownIndicator, __assign({}, props));
  };
  var SingleValue = function (props) {
    var Icon = props.data.icon || props.data.valueIcon;
    var Image = props.data.image || props.data.singleValueImage;
    return React.createElement(Components.SingleValue, __assign({}, props), React.createElement(My.ValueLayout, null, Image && React.createElement(My.SingleValueImage, null, React.createElement(My.Image, {
      _round: props.data.round,
      src: Image
    }), React.createElement(My.SingleValueBorder, null)), !Image && Icon && React.createElement(My.Icon, {
      size: isSearch ? 18 : 24,
      color: props.data.color || 'text'
    }, React.createElement(Icon, null)), props.children, props.data.badge && React.createElement(My.Badge, null, props.data.badge)));
  };
  var MultiValue = function (props) {
    var Icon = props.data.icon || props.data.valueIcon;
    var image = props.data.image;
    return React.createElement(Components.MultiValue, __assign({}, props), React.createElement(My.ValueLayout, null, image && React.createElement(My.MultiValueImage, null, React.createElement(My.MultiImage, {
      _round: props.data.round,
      src: image
    })), !image && Icon && React.createElement(My.MultiValueIcon, {
      size: props.data.tall ? 28 : 18,
      color: props.data.color || 'text'
    }, React.createElement(Icon, null)), props.children));
  };
  var isCreatable = !!onCreateOption;
  var Select = loadOptions ? My.AsyncSelectPaginate : My.Select;
  var selectProps = pickBy({
    options: !loadOptions && options,
    borderless: borderless,
    SelectComponent: isCreatable ? Creatable : Select
  });
  return React.createElement(My.Container, {
    className: cls.name(className)
  }, React.createElement(Select, __assign({
    classNamePrefix: cn('select'),
    components: __assign({
      Option: Option,
      SingleValue: SingleValue,
      MultiValue: MultiValue,
      DropdownIndicator: DropdownIndicator
    }, props.components || {}),
    isDisabled: isDisabled,
    id: id,
    // ref={ref}
    onCreateOption: onCreateOption,
    formatCreateLabel: formatCreateLabel,
    onChange: onChange,
    placeholder: isLoading ? 'Please wait...' : placeholder || '(None)',
    isSearchable: isSearchable,
    name: name || id,
    value: optionValue,
    valid: valid,
    loadOptions: loadOptions,
    defaultOptions: defaultOptions,
    filterOption: createFilter({
      ignoreAccents: false
    }),
    isMulti: isMulti,
    isOptionDisabled: isOptionDisabled,
    noOptionsMessage: noOptionsMessage,
    isClearable: isClearable,
    styles: ReactSelectStyles
  }, selectProps)));
};
SelectComponent.defaultProps = SelectDefaultProps;
export var Select = withTheme(SelectComponent);
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19, templateObject_20, templateObject_21, templateObject_22, templateObject_23, templateObject_24, templateObject_25, templateObject_26, templateObject_27, templateObject_28, templateObject_29, templateObject_30, templateObject_31, templateObject_32, templateObject_33, templateObject_34, templateObject_35, templateObject_36, templateObject_37, templateObject_38, templateObject_39, templateObject_40, templateObject_41, templateObject_42, templateObject_43, templateObject_44, templateObject_45;